
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__sites/[site]",
      function () {
        return require("private-next-pages/__sites/[site]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__sites/[site]"])
      });
    }
  